var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.464 2.1l-.707-.707L4.93 4.222 2.1 1.393l-.708.708 2.829 2.828-2.829 2.828.708.707 2.828-2.828 2.828 2.828.707-.707L5.636 4.93 8.464 2.1z","stroke":"#000","fill":"none","fillRule":"evenodd"}));
}

Cross.defaultProps = {"width":"10","height":"10"};

module.exports = Cross;

Cross.default = Cross;
